(function () {
  "use strict";

  /* ------------------------------------------------------------
     TB Mobile Products Bar (time-delay only)
     - Mobile-only
     - Shows after X seconds (data-delay)
     - Close hides for 24 hours (localStorage timestamp)
     - Safe with Shopify Theme Editor section reloads
  ------------------------------------------------------------ */

  var STORAGE_KEY = "tb_mfpb_closed_until"; // global 24h cooldown
  var COOLDOWN_MS = 24 * 60 * 60 * 1000;   // 24 hours
  var MOBILE_QUERY = "(max-width: 797px)";

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia(MOBILE_QUERY).matches);
  }

  function getCooldownUntil() {
    try {
      return parseInt(localStorage.getItem(STORAGE_KEY) || "0", 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function inCooldown() {
    var until = getCooldownUntil();
    return until && Date.now() < until;
  }

  function setCooldown() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + COOLDOWN_MS));
    } catch (e) {}
  }

  function initBar(bar) {
    if (!bar || bar.dataset.tbMfpbInit === "1") return;
    bar.dataset.tbMfpbInit = "1";

    // Mobile-only: exit early
    if (!isMobile()) return;

    // Respect 24h dismissal; also ensure spacer isn't left behind
    if (inCooldown()) {
      document.documentElement.classList.remove("tb-mfpb-open");
      bar.classList.remove("is-visible");
      bar.setAttribute("aria-hidden", "true");
      return;
    }

    var delaySeconds = parseFloat(bar.getAttribute("data-delay"));
    if (!isFinite(delaySeconds)) delaySeconds = 6;

    var shown = false;
    var closed = false;
    var timerId = null;

    function show() {
      if (shown || closed) return;
      shown = true;

      bar.classList.add("is-visible");
      bar.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("tb-mfpb-open");
    }

    function hide() {
      if (closed) return;
      closed = true;

      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }

      bar.classList.remove("is-visible");
      bar.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("tb-mfpb-open");
    }

    // Close button
    var closeBtn = bar.querySelector(".tb-mfpb__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        hide();
        setCooldown();
      });
    }

    // Time-based trigger only
    function scheduleShow() {
      timerId = window.setTimeout(show, Math.max(0, delaySeconds) * 1000);
    }

    // Defer timer scheduling until idle (small CWV win)
    if ("requestIdleCallback" in window) {
      requestIdleCallback(scheduleShow, { timeout: 2000 });
    } else {
      scheduleShow();
    }
  }

  function boot() {
    // Small fast exit (avoid DOM work)
    if (!isMobile()) return;

    var bars = document.querySelectorAll(".tb-mfpb");
    if (!bars.length) return;

    for (var i = 0; i < bars.length; i++) {
      initBar(bars[i]);
    }
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Theme editor / dynamic reload support
  document.addEventListener("shopify:section:load", boot);
})();